export { OnDemandPreloadingStrategy } from './on-demand-preloading-strategy.service';
export { PreloadRoute } from './preload-route.service';
export { PreloadModule, PreloadRouteConfig } from './preload-route.config';
